import type { ReactNode } from "react";

/**
 * El marco de un resultado con datos: una tabla o un gráfico.
 *
 * Los dos se ven igual por fuera --título arriba, algo a la derecha, el
 * contenido debajo-- y el gráfico puede cambiarse por su tabla sin que el
 * marco se mueva. Tenerlo una sola vez es lo que garantiza eso.
 */
export function Figure({
  title,
  aside,
  children,
  footer,
}: {
  title: ReactNode;
  /** A la derecha del título: el número de filas, o el botón de cambiar vista. */
  aside?: ReactNode;
  children: ReactNode;
  /** Pegado al borde inferior, sin margen: "ver más". */
  footer?: ReactNode;
}) {
  return (
    <figure className="m-0 overflow-hidden rounded-lg border bg-card">
      <figcaption className="flex items-baseline gap-3 border-b px-4 py-2">
        <span className="text-sm font-semibold">{title}</span>
        {aside !== undefined && <div className="ml-auto">{aside}</div>}
      </figcaption>

      {children}

      {footer !== undefined && <div className="border-t">{footer}</div>}
    </figure>
  );
}
